export default __webpack_public_path__ + "static/media/who-we-are-img-07.f5f46b73.jpg";